<div class="modal-body content width-900 height-900">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
	    {{getRessource('modalHeader')}}
    </span>
		<div class="content layout-auto-1-auto">
			<!-- Search Header -->
        <exg-search-bar (Search)="taskTable.search($event)" [placeholder]="getRessource('SearchHolder')"
                        class="span-layout">
          <ng-template #rightTemplate>
          <i (click)="taskTable.loadData()" class="search-action fal fa-sync"></i>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-filter"
                 [class.fas]="taskTable.uiFilterAktiv(1).length > 0"
                 [class.fal]="taskTable.uiFilterAktiv(1).length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCtaskTableFilterControl
                              (onActivateFilter)="taskTable.pageChanged(1);popup.close()"
                              [MetaInfo]="taskTable.MetaInfo"
                              [visibility]="popup.visibility !== 'hidden'"
                              [showFilter]="true" [uiFilter]="taskTable.uiFilter"
                              [uiSort]="taskTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-sort-alt"
                 [class.fas]="taskTable.uiSortAktiv().length > 0"
                 [class.fal]="taskTable.uiSortAktiv().length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCtaskTableSortControl
                              (onActivateFilter)="taskTable.pageChanged(1);popup.close()"
                              [MetaInfo]="taskTable.MetaInfo"
                              [visibility]="popup.visibility !== 'hidden'"
                              [showSort]="true" [uiFilter]="taskTable.uiFilter"
                              [uiSort]="taskTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-binoculars"
                 [class.fas]="taskTable.uiFilterAktiv(2).length > 0"
                 [class.fal]="taskTable.uiFilterAktiv(2).length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter (onActivateFilter)="taskTable.pageChanged(1);popup.close()"
                              [MetaInfo]="taskTable.MetaInfo" #VCtaskTableSearchControl
                              [showSearch]="true" [uiFilter]="taskTable.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="taskTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <i class="search-action fal fa-gears"
             (click)="openTableSettings($event)">
          </i>
          <exg-table-settings #tableDefinitionSettings
                              [tableDef]="taskTable.tableDefinition"
                              [metaInfo]="taskTable.MetaInfo"
                              localStorageID="taskTable">
          </exg-table-settings>
          <i class="search-action fal fa-list"
             *ngIf="enableMultiSelection"
             [class.c-green]="taskTable.multiSelection"
             (click)="taskTable.toggleMultiSelection()"
             [tooltip]="getRessource('TooltipToggleMultiSelection')" flow="left">
          </i>
        </ng-template>
      </exg-search-bar>
			<!-- DataTable -->
			<div class="content">
				<exg-table #VCtaskTableV2
				           (RowChange)="taskTable.selectionChanged($event)"
				           (FilterActivation)="taskTable.loadData()"
				           [selectSource]="taskTable.selectedRows"
				           [selectKey]="taskTable.selectKey"
				           [rowSource]="taskTable.data"
				           [tableDef]="taskTable.tableDefinition"
				           [distinctTableName]="'Vorgaenge'"
				           [metaInfo]="taskTable.MetaInfo"
				           [displayState]="taskTable.state"
				           class="content"
				           [allowMultiSelection]="taskTable.multiSelection"
				           [allowSingleSelection]="!taskTable.multiSelection"
				           (loadDistinct)="taskTable.getDistinctData($event)"
				           [distinctData]="taskTable.distinctData">
				</exg-table>
			</div>
			<!-- Pager -->
      <exg-pager (PageChange)="taskTable.pageChanged($event)"
                 [pagingSource]="taskTable.paging"
                 class="span-layout">
        <ng-template #leftTemplate>
          <app-exg-dropdown *ngIf="preFilterDefinition && preFilterDefinition.length" class="typo-small" [list]="preFilterDefinition" elementclass="typo-left" maxHeight="250px"
                            [label]="selectedMod?.caption" position="abovecenter" listdisplay="caption"
                            (change)="changePreFilterMod($event.value)" >
          </app-exg-dropdown>
          <app-exg-dropdown *ngIf="preFilterDefinition && preFilterDefinition.length" class="typo-small" [list]="selectedMod?.types" elementclass="typo-left" maxHeight="250px"
                            [label]="selectedType?.caption" position="abovecenter" listdisplay="caption"
                            (change)="changePreFilterType($event.value)">
          </app-exg-dropdown>
        </ng-template>


        <ng-template #rightTemplate>
          <div class="app-pager-chips">
            <app-exg-filter-chips #VCFilterChips
                                  [inputDataTable]="taskTable"
                                  [VCFilterControl]="{ VCFilter: VCtaskTableFilterControl, VCSearch: VCtaskTableSearchControl, VCSort: VCtaskTableSortControl}">
            </app-exg-filter-chips>
          </div>
        </ng-template>
      </exg-pager>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="action()"
			        [disabled]="dirty()"
			        class="md-btn">
				{{getGlobal('Save')}}
			</button>
			<button (click)="close()" class="md-btn">
				{{getGlobal('Close')}}
			</button>
		</div>
	</div>
</div>
